import { action } from 'typesafe-actions';
import { ChargePackageActionTypes } from "./types"

export const FetchChargePackage = (data: any) => action(ChargePackageActionTypes.FETCH_CHARGE_PACKAGE_TYPES, data)

export const SetChargePackage = (data: any) => action(ChargePackageActionTypes.SET_CHARGE_PACKAGE_TYPES, data)

export const SetPaymentType = (data: number) => action(ChargePackageActionTypes.SET_PAYMENT_TYPE, data)

export const SetStatus = (data: string) => action(ChargePackageActionTypes.SET_TRANSACTION_STATUS, data)
